<template lang="html">
  <div :class="['input-wrapper', error && 'error']">
    <input
      type="text"
      :placeholder="placeholder"
      class="input"
      @input="(event) => onChange(event.target.value)"
      :value="value"
    />
    <span class="msg-error">{{ error }}</span>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: String,
    error: String,
    value: String,
    onChange: Function,
  },
};
</script>
<style lang="css" scoped>
.input-wrapper {
  display: flex;
  flex-direction: column;
}
.input-wrapper .input {
  background: #ffffff;
  border: 2px solid #e0e0e1;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 12px 20px;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  color: #013652;
  outline: none;
}
.input-wrapper .input::placeholder {
  color: #696f72;
}
.input-wrapper:hover .input::placeholder {
  color: rgba(1, 54, 82, 0.8);
}
.input-wrapper .input:focus {
  border: 2px solid rgba(1, 54, 82, 0.8);
}
.input-wrapper .msg-error {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #c42020;
  margin-left: 20px;
  margin-top: 5px;
  display: none;
}
.input-wrapper.error .msg-error {
  display: block;
}
.input-wrapper.error .input {
  border: 2px solid #c32020;
  color: #c32020;
}
</style>
